import { DistrictActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { DistrictFormData } from 'src/screens/General/screens/Districts/components/DistrictForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetDistrictsAction {
    type: typeof DistrictActions.FETCH_DISTRICTS;
    payload: QueryParams;
}

export function getDistricts(params: QueryParams): GetDistrictsAction {
    return {
        type: DistrictActions.FETCH_DISTRICTS,
        payload: params,
    };
}

export interface GetDistrictsSmallAction {
    type: typeof DistrictActions.FETCH_DISTRICTS_SIMPLY;
    payload: QueryParams;
}

export function getDistrictsSmall(params: QueryParams): GetDistrictsSmallAction {
    return {
        type: DistrictActions.FETCH_DISTRICTS_SIMPLY,
        payload: params,
    };
}

export interface GetDistrictAction {
    type: typeof DistrictActions.FETCH_DISTRICT;
    payload: {
        id: string | number;
    };
}

export function getDistrict(id: string | number): GetDistrictAction {
    return {
        type: DistrictActions.FETCH_DISTRICT,
        payload: { id },
    };
}

export interface DeleteDistrictAction {
    type: typeof DistrictActions.DELETE_DISTRICT;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteDistrict(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteDistrictAction {
    return {
        type: DistrictActions.DELETE_DISTRICT,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistDistrictAction {
    type: typeof DistrictActions.PERSIST_DISTRICT;
    payload: {
        data: DistrictFormData;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export function persistDistrict(
    data: DistrictFormData,
    files: any,
    callbacks: SagaPromise<any>,
): PersistDistrictAction {
    return {
        type: DistrictActions.PERSIST_DISTRICT,
        payload: {
            data,
            files,
            callbacks,
        },
    };
}

export const asyncPersistDistrict = (data: DistrictFormData, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistDistrict(data, files, { resolve, reject }));
    });
};

export const asyncCreateFilesDistrict = (id: number | string, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(createFilesDistrict(id, files, { resolve, reject }));
    });
};

export interface CreateFilesDistrictAction {
    type: typeof DistrictActions.CREATE_FILES_DISTRICT;
    payload: {
        id: number | string;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export function createFilesDistrict(
    id: number | string,
    files: any,
    callbacks: SagaPromise<any>,
): CreateFilesDistrictAction {
    return {
        type: DistrictActions.CREATE_FILES_DISTRICT,
        payload: {
            id,
            files,
            callbacks,
        },
    };
}

export interface GetFilesAction {
    type: typeof DistrictActions.FETCH_FILES_DISTRICT;
    payload: {
        id: string | number;
    };
}

export function getFiles(id: string | number): GetFilesAction {
    return {
        type: DistrictActions.FETCH_FILES_DISTRICT,
        payload: { id },
    };
}

export interface DeleteFileDistrictAction {
    type: typeof DistrictActions.DELETE_FILE_DISTRICT;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteFileDistrict(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteFileDistrictAction {
    return {
        type: DistrictActions.DELETE_FILE_DISTRICT,
        payload: { id, onSuccess, onError },
    };
}

export type Actions = GetDistrictsAction | GetDistrictAction | DeleteDistrictAction | PersistDistrictAction;
